// @ts-check
import LeftPanelItem from "Components/LeftPanel/leftPanelItem";
import { MainItems } from "Stores/LeftPanel/MainItems";
import { MkMessagingItems } from "Stores/LeftPanel/MkMessagingItems";
import { UserSettingsItems } from "Stores/LeftPanel/UserSettingsItems";
import { UsersServerSettingsItems } from "Stores/LeftPanel/UsersServerSettingsItems";
import Helper from "Utils/Helper";
import { observer } from "mobx-react";
import React from "react";
import { useLocation } from "react-router-dom";
import { DeviceTracesItems } from "Stores/LeftPanel/DeviceTracesItems";

// todo перенести в view

const LeftPanelItems = () => {
    let location = useLocation();
    let path = Helper.RemovePrefix(location.pathname, window.SmrLocation);

    /** @type {import("Stores/LeftPanel/MainItems").LeftPanelItemState[]} */
    let items;
    if (path.startsWith('/userSettings'))
        items = UserSettingsItems();
    else if (path.startsWith('/mkMessaging/viewMessage') || path.startsWith('/mkMessaging/newMessage'))
        items = MkMessagingItems();
    else if (path.startsWith('/users/serversettings'))
        items = UsersServerSettingsItems();
    else if (path.startsWith('/users/deviceTrace'))
        items = DeviceTracesItems();
    else
        items = MainItems(path);

    return (
        <div>
            {items.map(x => <LeftPanelItem key={x.id} {...x} />)}
        </div>
    )
};

export default observer(LeftPanelItems);